import { TaskGroupCard } from '../task-group-card/TaskGroupCard'
import { TaskDetails } from '../../utils/taskHelper'
import { EmptyState, Mtds } from 'prove-common'

export type TaskGroupItem = {
  key: string
  groupId: string
  details: TaskDetails
  isCompleted: boolean
}

export type TaskGroupListProps = {
  taskGroupItems: TaskGroupItem[]
  isFiltering: boolean
}

export const TaskGroupList = ({
  taskGroupItems,
  isFiltering
}: TaskGroupListProps) =>
  taskGroupItems.length ? (
    <Mtds.Grid>
      {taskGroupItems.map(({ key, groupId, ...rest }) => (
        <TaskGroupCard key={key} id={groupId} {...rest} />
      ))}
    </Mtds.Grid>
  ) : (
    <EmptyState
      title={isFiltering ? 'Ingen treff' : 'Ingen oppgaver'}
      description={
        isFiltering
          ? 'Prøv andre filtervalg.'
          : 'Ingen oppgaver å vise for denne avdelingen.'
      }
    />
  )
